import {toast} from '@wandb/weave/common/components/elements/Toast';
import {Link} from '@wandb/weave/common/util/links';
// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import * as Dialog from '@wandb/weave/components/Dialog';
import {Icon} from '@wandb/weave/components/Icon';
import React, {useState} from 'react';

import {useTriggerFlatRunsMigratorMutation} from '../../generated/graphql';

export type RunsV2TargetType = 'entity' | 'organization';

interface TriggerRunsV2ModalProps {
  name: string;
  type: RunsV2TargetType;
  isOpen: boolean;
  onClose: () => void;
}

const TriggerRunsV2Modal: React.FC<TriggerRunsV2ModalProps> = ({
  name,
  type,
  isOpen,
  onClose,
}) => {
  const [triggerMigrator, {loading}] = useTriggerFlatRunsMigratorMutation();
  const [success, setSuccess] = useState<boolean | null>(null);
  const [glueTaskName, setGlueTaskName] = useState<string | null>(null);

  const handleTriggerMigrator = async () => {
    if (!name) {
      toast(`${type} name is required`, {type: 'warning'});
      return;
    }

    try {
      const {data} = await triggerMigrator({
        variables: {
          organizationName: type === 'organization' ? name : undefined,
          entityName: type === 'entity' ? name : undefined,
        },
      });

      const taskName = data?.triggerFlatRunsMigrator?.glueTaskName;
      if (taskName) {
        setGlueTaskName(taskName);
        setSuccess(true);
      }
    } catch (error) {
      console.error('Failed to trigger runs v2 migration:', error);
      setSuccess(false);
    }
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay />
        <Dialog.Content className="w-[600px] rounded-lg">
          <Dialog.Title>
            <div className="flex items-center">
              <Icon name="warning-alt" className="mr-10" />
              Migrate to Runs V2
            </div>
          </Dialog.Title>
          {success == null ? (
            <>
              <Dialog.Description className="pt-16 leading-relaxed">
                Are you sure you want to trigger Runs V2 migration for {type}{' '}
                <b>{name}</b>? This might take a while.
              </Dialog.Description>
              <div className="mt-24 flex justify-end gap-8">
                <Button
                  onClick={handleTriggerMigrator}
                  variant="primary"
                  size="large"
                  disabled={loading}>
                  {loading ? 'Triggering...' : 'Trigger'}
                </Button>
                <Dialog.Close>
                  <Button onClick={onClose} variant="ghost" size="large">
                    Cancel
                  </Button>
                </Dialog.Close>
              </div>
            </>
          ) : success ? (
            <>
              <Dialog.Description className="pt-16 leading-relaxed">
                Successfully triggered Runs V2 migration for {type}{' '}
                <b>{name}</b> ✅ Check the status of migration task{' '}
                <Link
                  className="font-bold text-blue-500"
                  to={`/admin/glue?search=${glueTaskName}`}>
                  here in the admin glue dashboard
                </Link>
                .
              </Dialog.Description>
              <div className="mt-24 flex justify-end gap-8">
                <Dialog.Close>
                  <Button onClick={onClose} variant="primary" size="large">
                    Close
                  </Button>
                </Dialog.Close>
              </div>
            </>
          ) : (
            <Dialog.Description className="pt-16 leading-relaxed">
              Failed to trigger Runs V2 migration ❌ Please try again.
            </Dialog.Description>
          )}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default TriggerRunsV2Modal;
